import React, {useEffect, useRef} from 'react';
import {Breadcrumb, Layout, Menu} from 'antd';
import {Link, Route, Switch, useHistory, useLocation, useRouteMatch} from 'react-router-dom';
import Users from './Users/Users';
import Profile from './Profile';
import AppHeader from '../components/Header';
import {useTranslation} from 'react-i18next';
import {useLazyGetApiAuthMeQuery} from '../api/services/auth';
import {setLoading} from '../features/app/appSlice';
import {useDispatch, useSelector} from 'react-redux';
import {setUserInfo} from '../features/auth/authSlice';
import SideMenu from '../components/SideMenu';
import Dashboard from './Dashboard/Dashboard';
import ParametersPage from './Parameters/ParametersPage';
import SystemRoleManagement from './Roles/SystemRoleManagement';
import UserRoleDefinitions from './Roles/UserRoleDefinitions';
import {RootState} from "../app/store";
import MCompanyGroups from "./SystemManagement/CompanyGroups/MCompanyGroups";
import Companies from "./SystemManagement/Companies/Companies";
import LogViewer from "./SystemManagement/Logs/LogViewer";
import MCompanyDetails from "./SystemManagement/CompanyDetails/MCompanyDetails";
import NudgingEmails from "./NudgingEmails/NudgingEmails";
import NotFoundPage from "../components/NotFoundPage";
import DashboardConfigurator from "./DashboardConfigurator/DashboardConfigurator";

const {Sider, Content} = Layout;


const Home: React.FC = () => {
    const {t} = useTranslation();
    let {path, url} = useRouteMatch();
    const location = useLocation();
    const [getMyData, {data: userData, isLoading: myDataLoading}] = useLazyGetApiAuthMeQuery()
    const dispatch = useDispatch();
    const tenantInfo = useSelector((state: RootState) => state.persisted?.tenantInfo);
    const tenantLoadingState = useSelector((state: RootState) => state.persisted?.isTenantLoaded);
    const history = useHistory();

    useEffect(() => {
        if (tenantLoadingState && !tenantInfo) {
            history.push(`/404`);
        }
    }, [tenantInfo, tenantLoadingState]);

    useEffect(() => {
        dispatch(setLoading(myDataLoading))
    }, [myDataLoading])

    useEffect(() => {
        getMyData()
    }, [])

    useEffect(() => {
        if (userData) {
            dispatch(setUserInfo(userData))
        }
    }, [userData])

    const generateBreadcrumbs = () => {
        const pathSnippets = location.pathname.split('/').slice(2).filter((i) => i);

        const breadcrumbs = (pathSnippets ?? []).map((_, index) => {
            const url = `${pathSnippets.slice(0, index + 1).join('/')}`;
            return <Breadcrumb.Item key={url}><Link to={url}>{t(url)}</Link></Breadcrumb.Item>;
        });

        return (
            <Breadcrumb style={{margin: '16px 0'}}>
                <Breadcrumb.Item key="home"><Link to={`/${tenantInfo?.id}/`}>{t('home')}</Link></Breadcrumb.Item>
                {breadcrumbs}
            </Breadcrumb>
        );
    };

    return (
        <Layout style={{height: '100vh'}}>
            <AppHeader/>
            <Layout>
                <Sider width={250} style={{margin: 10, borderRadius: 10, overflow: "hidden"}}>
                    <SideMenu/>
                </Sider>
                <Layout style={{padding: '0 24px 24px'}}>
                    <Content style={{margin: '16px', display: 'flex', flexDirection: 'column'}}>
                        {generateBreadcrumbs()}
                        <div style={{
                            padding: 24,
                            background: '#fff',
                            borderRadius: '16px',
                            flexGrow: 1,
                            overflow: 'auto'
                        }}>
                            <Switch>
                                <Route path={`/:id/users`} component={Users}/>
                                <Route path={`/:id/profile`} component={Profile}/>
                                <Route path={`/:id/parameters`} component={ParametersPage}/>
                                <Route path={`/:id/systemrole`} component={SystemRoleManagement}/>
                                <Route path={`/:id/userrole`} component={UserRoleDefinitions}/>
                                
                                <Route path={`/:id/nudgingemails`} component={NudgingEmails}/>
                                <Route path={`/:id/dashboardscreens`} component={DashboardConfigurator}/>

                                <Route path={`/:id/logviewer`} component={LogViewer}/>
                                <Route path={`/:id/company_groups`} component={MCompanyGroups}/>
                                <Route path={`/:id/companies/:groupId`} component={Companies}/>
                                <Route path={`/:id/companydetails/:groupId/:companyId`} component={MCompanyDetails}/>
                                
                                <Route exact path={`/:id`} component={Dashboard}/>
                                <Route path="*" component={NotFoundPage}/>
                            </Switch>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
};

export default Home;
